'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/productVariation'));
    processInclude(require('./product/notifyMe'));
    processInclude(require('wishlist_custom/product/wishlist'));
    processInclude(require('wishlist_custom/product/wishlistHeart'));
});
